module.exports = __webpack_public_path__ + "img/finishChecked.ed9a7025.png";